import versions from './versions'

class WorkflowDecorator {
  wrapped = {}

  setDecorator (version) {
    this.wrapped = versions[version]
  }

  findAll () {
    return this.wrapped.findAll()
  }
}

export default new WorkflowDecorator()
